<div class="wrap">


  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>
  </div>

  <section *ngIf="!isLoading">
    <form [formGroup]="dateForm" (ngSubmit)="onSubmit()" *ngIf="dateForm">
      <mat-form-field appearance="outline" class="dateField">
        <mat-label>Date de départ</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" (focus)="startDatePicker.open()">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dateField">
        <mat-label>Date de fin</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [min]="dateForm.value.startDate" formControlName="endDate"
          (focus)="endDatePicker.open()">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>

      <fa-icon class="search_button" [icon]="getFaIcon('faSearch')" appChangeColorTheme attribute="color"
        (click)="onSubmit()" [matTooltip]="getTooltip('doSearch')"></fa-icon>
    </form>
  </section>

  <div class="search_bar" *ngIf="sessions.length > 0">
    <form [formGroup]="searchForm" *ngIf="searchForm">
      <input type="text" placeholder="Chercher une session..." (input)="applyFilter($event.target.value)"
        formControlName="keyword">
    </form>

    <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
    <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

  </div>

  <section [hidden]="sessions.length === 0 || isLoading">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="offerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Offre </th>
        <td mat-cell *matCellDef="let session"> {{ session.offerName }} </td>
      </ng-container>

      <ng-container matColumnDef="dateLib">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Session </th>
        <td mat-cell *matCellDef="let session">{{ session.dateLib}} </td>
      </ng-container>

      <ng-container matColumnDef="sessionStartDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de début </th>
        <td mat-cell *matCellDef="let session"> {{ session.sessionStartDate}} </td>
      </ng-container>

      <ng-container matColumnDef="sessionEndDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de fin </th>
        <td mat-cell *matCellDef="let session"> {{ session.sessionEndDate}} </td>
      </ng-container>

      <ng-container matColumnDef="bookedSessionTrainees">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Stagiaire(s) </th>
        <td mat-cell *matCellDef="let session"> {{ session.bookedSessionTrainees}}/{{ session.quantity}} </td>
      </ng-container>

      <ng-container matColumnDef="rating">
        <th mat-header-cell mat-sort-header="rating" *matHeaderCellDef> Note </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ratingTotal > 0">
            <span (click)="openDialogRatings(element)" appChangeColorTheme attribute="color" class="ratings">
              {{element.rating}}
            <sup *ngIf="element.ratingTotal > 1">
              <fa-icon class="faInfoCircle" [icon]="getFaIcon('faInfoCircle')" [matTooltip]="'Moyenne des ' + element.ratingTotal + ' notes réalisées par les utilisateurs de l\'activité'" appChangeColorTheme attribute="color"></fa-icon>
            </sup>
            </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
        <td mat-cell *matCellDef="let session"> {{ session.status}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="center"> Actions </th>
        <td mat-cell *matCellDef="let session" class="center">
          <fa-icon *ngIf="session.status === 'Enregistrée'" (click)="changeStatus(2, session)" [icon]="getFaIcon('faCalendarCheck')" appChangeColorTheme attribute="color" matTooltip="Rendre la session planifiée"></fa-icon>
          <fa-icon *ngIf="session.status === 'Planifiée'" (click)="changeStatus(3, session)" [icon]="getFaIcon('faCheck')" appChangeColorTheme attribute="color" matTooltip="Rendre la session terminée"></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row">
      </tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </section>

  <ng-container *ngIf="sessions.length === 0 && !isLoading">
    <p>Il n'y a aucune session dans cette tranche de dates.</p>
  </ng-container>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

</div>
